import { Component, inject } from '@angular/core';
import { DayService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DayCreateDto,
  DayDto,
  DayExcelDownloadDto,
  DayUpdateDto,
} from '../proxy/general/dtos/day';
import { DAY_CONFIG, DAY_FIELDS } from './day.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-day',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DayService, ConfirmationService],
  templateUrl: './day.html',
  styleUrl: './day.scss',
})
export class Day extends BaseCrudComponent<
  DayDto,
  DayCreateDto,
  DayUpdateDto,
  DayExcelDownloadDto
> {
  service = inject(DayService);
  config = DAY_CONFIG;
  fields = DAY_FIELDS;

  protected prepareUpdateDto(data: any, selected: DayDto): DayUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Day';
  }
}
